import { contactInfo } from '@/mocks/home';

export default function Contact() {
  return (
    <section id="contact" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-screen-2xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <div className="inline-flex items-center gap-2 bg-accent-100/70 text-accent-700 text-xs font-medium px-3 py-1 rounded-full mb-4">
            <i className="ri-mail-send-line text-xs"></i>
            <span>联系我们</span>
          </div>
          <h2 className="font-heading text-2xl md:text-4xl text-foreground-950 mb-3">
            {contactInfo.title}
          </h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-xl mx-auto">
            期待你的声音，共建更好的漫画阅读社区
          </p>
        </div>

        <div className="max-w-4xl mx-auto">
          <div className="bg-background-50 border border-background-200/70 rounded-lg p-6 md:p-10">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
              <div>
                <p className="text-foreground-600 text-sm md:text-base leading-relaxed mb-6">
                  {contactInfo.desc}
                </p>
                <div className="space-y-4">
                  <div className="flex items-center gap-3">
                    <div className="w-10 h-10 flex items-center justify-center bg-primary-100 rounded-lg shrink-0">
                      <i className="ri-mail-line text-primary-600 text-lg"></i>
                    </div>
                    <div>
                      <div className="text-xs text-foreground-400">电子邮箱</div>
                      <div className="text-sm text-foreground-800 font-medium">{contactInfo.email}</div>
                    </div>
                  </div>
                  <div className="flex items-center gap-3">
                    <div className="w-10 h-10 flex items-center justify-center bg-accent-100 rounded-lg shrink-0">
                      <i className="ri-wechat-line text-accent-600 text-lg"></i>
                    </div>
                    <div>
                      <div className="text-xs text-foreground-400">微信公众号</div>
                      <div className="text-sm text-foreground-800 font-medium">{contactInfo.wechat}</div>
                    </div>
                  </div>
                  <div className="flex items-center gap-3">
                    <div className="w-10 h-10 flex items-center justify-center bg-secondary-100 rounded-lg shrink-0">
                      <i className="ri-qq-line text-secondary-600 text-lg"></i>
                    </div>
                    <div>
                      <div className="text-xs text-foreground-400">QQ群</div>
                      <div className="text-sm text-foreground-800 font-medium">{contactInfo.qq}</div>
                    </div>
                  </div>
                </div>
              </div>

              <div>
                <img
                  src="https://readdy.ai/api/search-image?query=Warm%20friendly%20customer%20support%20scene%20with%20manga%20themed%20decorations%2C%20soft%20ambient%20lighting%2C%20cozy%20atmosphere%2C%20creative%20workspace%20with%20comic%20art%20on%20walls%2C%20professional%20yet%20approachable%20vibe%2C%20warm%20coral%20and%20cream%20tones%2C%20editorial%20photography%2C%20high%20quality&width=600&height=480&seq=contact-manga-support&orientation=landscape"
                  alt="古古漫画网联系与支持"
                  className="w-full h-56 md:h-full min-h-[260px] object-cover object-top rounded-lg"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}